import styled from 'styled-components';
import {scaleDesktop} from 'styled/scaleDesktop';

interface Props {
  widthPhoto?: number
  heightPhoto?: number
  marginBottom?: number
  opacityBackground?: number
}

const widthWidgetGameLinePhoto = 62;
const borderAfterWidgetGameLinePhoto = 80;
const marginBottomWidgetGameLinePhoto = 0;
const opacityBackgroundGameLinePhoto = 0.35;

export const WidgetGameLinePhoto = styled.div<Props>`
  position: relative;
  display: block;
  width: ${({widthPhoto = widthWidgetGameLinePhoto, theme}) => scaleDesktop(widthPhoto, theme.horizontal)};
  height: ${({widthPhoto = widthWidgetGameLinePhoto, theme}) => scaleDesktop(widthPhoto, theme.horizontal)};
  border-radius: ${({theme}) => scaleDesktop(borderAfterWidgetGameLinePhoto, theme.horizontal)};
  background-color: ${
    ({opacityBackground = opacityBackgroundGameLinePhoto}) => `rgba(15, 15, 15, ${opacityBackground})`
  };
  margin-bottom: ${
    ({marginBottom = marginBottomWidgetGameLinePhoto, theme}) => scaleDesktop(marginBottom, theme.horizontal)
  };
`;
